module.exports = __webpack_public_path__ + "static/media/loader.5bcc9d47.gif";